export const POST_DOCUMENT_APPROVEMENT_URL = '/aprovacao-documentos'

export const GET_DOCUMENT_FILE_URL = ({
  id_documento,
  id_corcc080
}: {
  id_documento: number
  id_corcc080: number
}) => `/aprovacao-documentos/${id_documento}/documentos/${id_corcc080}`

export const DELETE_DOCUMENT_FILE_URL = ({
  id_documento,
  id_corcc080
}: {
  id_documento: number
  id_corcc080: number
}) => `/aprovacao-documentos/${id_documento}/documentos/${id_corcc080}`

export const GET_LIST_DOCUMENTS_URL = '/aprovacao-documentos/listar-documentos'

export const PUT_DOCUMENT_FILE_URL = '/aprovacao-documentos/atualizar-status'

export const POST_ANALISE_DOCUMENTOS_URL = '/analise-documentos'

export const GET_ANALISE_DOCUMENTOS_URL = ({
  Guid,
  solicitacao
}: {
  Guid: string
  solicitacao: number
}) => `/analise-documentos/${Guid}/solicitacao/${solicitacao}`

export const GET_DOCUMENTOS_URL = ({ name }: { name: string }) =>
  `/documentos-materiais-apoio/nm-arquivo-exibicao?=${name}`

export const GET_DOCUMENTOS_BY_ID_URL = ({ id_corcc080 }: { id_corcc080: number }) =>
  `/documentos-materiais-apoio/${id_corcc080}`

export const DELETE_DOCUMENTOS_MATERIAL_URL = ({
  id_corcc132,
  id_corcc080
}: {
  id_corcc132: number
  id_corcc080: number
}) => `/documentos-materiais-apoio/${id_corcc132}/${id_corcc080}`

export const POST_DOCUMENTOS_URL = `/documentos-materiais-apoio`

export const GET_DOCUMENTOS_LIST_URL = ({ guid }: { guid: string }) =>
  `/analise-documentos/listar-realizados/${guid}`

export const DELETE_DOCUMENTOS_UPLOADED_URL = ({ guid }: { guid: string }) =>
  `/analise-documentos?guid=${guid}`

export const GET_DOCUMENTOS_CLIENTE_DADOS_URL = ({
  guid,
  cpf_cnpj
}: {
  guid: string
  cpf_cnpj: string
}) => `/documentos/${guid}/dados-cliente/cpf/${cpf_cnpj}`
